<template>
    <div class="row">
        <!--Title-->
        <div class="text-right col-md-12">
                <p-button 
                    v-if="tableData && tableData.length && !this.$apollo.queries.clientTypes.loading"
                    @click="handleAdd" 
                    type="warning" 
                    outline>Agregar tipo de cuota contingente
                    <i class="ml-2 fa fa-plus"></i>
                </p-button>
                <h4 class="title center-title pull-left">Tipos de cuota contingente - Agropecuario</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.clientTypes.loading"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Empty state-->
        <div v-if="tableData && !tableData.length && !this.$apollo.queries.clientTypes.loading" class="mt-3 col-md-12 card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <img class="no_data_center"  v-bind:src="no_data_image" alt="">
        </div>
        <div class="card-footer text-center">
            <p-button 
                @click="handleAdd" 
                type="warning" 
                outline>Agregar tipo de cuota contingente
                <i class="ml-2 fa fa-plus"></i>
            </p-button>            
        </div>
        </div>
        <!--./Empty state-->
        <!--Regionals data-->
        <div v-if="tableData &&  tableData.length && !this.$apollo.queries.clientTypes.loading" class="col-md-12 card">
        <div class="card-header">
            <div class="category">Lista de tipos de cuota contingente</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-4">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Buscar"
                            v-model="searchQuery"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in tableColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label">
                </el-table-column>
                <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Acciones">
                <template slot-scope="props">
                    <el-tooltip content="Editar" placement="left">
                    <p-button type="primary" size="sm" icon @click="handleEdit(props.$index, props.row)">
                        <i class="fa fa-edit"></i>
                    </p-button>
                    </el-tooltip>
                    <el-tooltip v-show="props.row.active" content="Desactivar" placement="right">
                    <p-button type="danger" size="sm" icon @click="handleDeactivate(props.$index, props.row)">
                        <i class="fa fa-pause"></i>
                    </p-button>
                    </el-tooltip>
                    <el-tooltip  v-show="!props.row.active" content="Activar" placement="right">
                    <p-button type="success" size="sm" icon @click="handleActivate(props.$index, props.row)">
                        <i class="fa fa-play"></i>
                    </p-button>
                    </el-tooltip>
                </template>
                
                </el-table-column>
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./Regionals data-->
        <!--Add Regional form-->
        <div v-if="(addContingentQuota == true || editContingentQuota == true) && !this.$apollo.queries.clientTypes.loading" class="col-md-12 card">
            <form>
                <div class="card-header">
                    <h4 class="card-title">
                    {{formName}}
                    </h4>
                </div>
                <div class="card-body">
                    
                    <div class="form-group">
                        <label>Tipo de cliente</label>
                        <fg-input name="rol">
                        <el-select class="select-warning"
                                    name="cliente"
                                    size="large"
                                    placeholder="Seleccione un Tipo de Cliente"
                                    v-validate="'required'"
                                    :error="errors.has('cliente')"
                                    v-model="model.code">
                            <el-option v-for="option in clientTypes_array"
                                    class="select-warning"
                                    :value="option.code"
                                    :label="option.name"
                                    :key="option.id">
                            </el-option>
                        </el-select>
                        <span v-show="errors.has('cliente')" class="text-danger">{{ errors.first('cliente') }}</span>
                    </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Saldo contingente TDC</label>
                        <fg-input   ref="balance"
                                    type="numeric"
                                    name="saldo"
                                    autocomplete="off"
                                    v-validate="modelValidations.balance"
                                    :error="getError('saldo')"
                                    v-model="model.balance">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Cuota contingente TDC</label>
                        <fg-input   ref="quota"
                                    type="numeric"
                                    name="cuota"
                                    autocomplete="off"
                                    v-validate="modelValidations.quota"
                                    :error="getError('cuota')"
                                    v-model="model.quota">
                        </fg-input>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button type="success" @click.prevent="validate">Aceptar</p-button>
                        <p-button type="default" class="pull-left" @click="cancelForm">Cancelar</p-button>
                    </div>
                </div>
            </form>
        </div>
        <!--./Add Regional form-->
    </div>
    
    </template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { clientTypes } from 'src/api/graphql/queries/setup/AllClientTypes';
    import { contingentQuotasTdcAgro } from 'src/api/graphql/queries/setup/AllContingentQuotaAgro';
    import { CREATE_CONTINGENT_QUOTA_AGRO } from 'src/api/graphql/mutations/setup/AddEditContingentQuotasTdcAgro';
    import { orderBy , sortBy , find } from 'lodash';
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        clientTypes: {
                    query: clientTypes,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.clientTypes.edges.length == 0)
                        {
                            this.clientTypes_array = [];
                        }
                        else
                        {
                            this.setClientTypes(data.clientTypes);
                            this.$apollo.queries.clientTypes.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
        contingentQuotasTdcAgro: {
                    query: contingentQuotasTdcAgro,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.contingentQuotasTdcAgro.edges.length == 0)
                        {
                            this.contingentQuotasTdcAgro_array = [];
                        }
                        else
                        {
                            this.setContingentQuotasTdcAgro(data.contingentQuotasTdcAgro);
                            this.$apollo.queries.contingentQuotasTdcAgro.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
        },
        components: {
        PPagination,
        Loading,
        [Tooltip.name]: Tooltip,
        Select,
        Option,
        },
        computed: {
        
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
        * Searches through table data and returns a paginated array.
        * Note that this should not be used for table with a lot of data as it might be slow!
        * Do the search and the pagination on the server and display the data retrieved from server instead.
        * @returns {computed.pagedData}
        */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            isSending: false,
            fullPage: false,
            tableData: [],
            clientTypes_array : [],
            contingentQuotasTdcAgro_array : [],
            addContingentQuota : false,//Bandera de creación de tipo de cuota contingente
            editContingentQuota : false,//Bandera de edición de tipo de cuota contingente
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                id: '',
                code: '',
                name: '',
                balance: null,
                quota: null

            },
            modelValidations: {
            code: {
                required: true,
                max: 8
            },
            name: {
                required: true,
                max: 32
            },
            balance: {
                required: true,
                numeric: true
            },
            quota: {
                required: true,
                decimal: 2
            },
            },
            pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
            },
            searchQuery: '',
            propsToSearch: ['name'],
            tableColumns: [
            {
                prop: 'name',
                label: 'Tipo de cuota contingente',
                minWidth: 250
            },
            {
                prop: 'balance',
                label: 'Saldo contingente',
                minWidth: 250
            },
            {
                prop: 'quota',
                label: 'Cuota contingente',
                minWidth: 250
            }
            ],
        }
        },
        methods: {
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setClientTypes(clientTypes){
                var vm = this;
                for(let i=0;i<clientTypes.edges.length;i++)
                {
                    vm.pushClientTypesData(clientTypes.edges[i].node);
                }
                vm.orderClientTypesData();  
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setContingentQuotasTdcAgro(contingentQuotasTdcAgro){
                var vm = this;
                for(let i=0;i<contingentQuotasTdcAgro.edges.length;i++)
                {
                    vm.pushData(contingentQuotasTdcAgro.edges[i].node);
                }
            },
            /*** 
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },
            /*** 
            * Función que se dispara cuando se da clic en Agregar tipo de cuota contingente
            */
            handleAdd (){
                var vm = this;
                let promise = new Promise(function(resolve, reject) {
                vm.resetForm();
                vm.formName = 'Agregar tipo de cuota contingente';
                vm.setVisibleForm(true,false)//Asignamos las variables de visualización del formulario
                vm.errors.clear();//Borramos las validaciones en los campos.
                resolve();
                }).then(function(resolve){
                vm.focusFirstField();
                });
                
            },
            /*** 
            * Función que se dispara cuando se da clic en Editar tipo de cuota contingente
            */
            handleEdit (index, row) {
                var vm = this;
                vm.rowEdit = row;
                let promise = new Promise(function(resolve, reject) {
                vm.formName = 'Editar tipo de cuota contingente';
                vm.model.id = row.id;
                vm.model.code = row.code;
                vm.model.name = row.name;
                vm.model.balance = row.balance;
                vm.model.quota = row.quota;
                vm.model.active = row.active;
                vm.setVisibleForm(false,true)//Asignamos las variables de visualización del formulario
                vm.errors.clear();//Borramos las validaciones en los campos.
                resolve();
                }).then(function(resolve){
                    vm.focusFirstField();
                });
            },
            /*** 
            * Función que se dispara cuando se da clic en Desactivar tipo de cliente
            */
            handleDeactivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, desactivarás la parametrización seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, desactivar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    this.isSending = true;
                    var formInput = {};
                    var id = vm.idDecode(row.id);
                    formInput = {
                            id: id,
                            data: JSON.stringify({
                                code: row.code,
                                name: (vm.clientTypes_array.find(client => client.code === row.code) || {}).name || 'Error', // Validación manual
                                balance: row.balance,
                                quota: row.quota,
                                active: false
                            })
                    };
                    this.$apollo.mutate({
                        mutation: CREATE_CONTINGENT_QUOTA_AGRO,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if (data.data.contingentQuotaTdcAgro.errors.length == 0) {
                            let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === row.id)
                            if (indexToDelete >= 0) {
                                vm.tableData.splice(indexToDelete, 1)
                            }
                            vm.pushData(data.data.contingentQuotaTdcAgro.contingentQuotaTDCAgro);
                            vm.orderData();
                            vm.isSending = false;
                            swal({
                            title: '¡Desactivada!',
                            text: 'La parametrización ha sido desactivada',
                            type: 'success',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                            }).then(() => {
                                vm.reloadData();
                            },function (dismiss){
                                vm.reloadData();
                            });
                        }
                        else {
                            vm.isSending = false;
                            vm.showNotificationError(data.data.contingentQuotaTdcAgro.errors[0].messages[0]);
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'La parametrización no ha sido desactivada',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /*** 
            * Función que se dispara cuando se da clic en Desactivar tipo de cliente
            */
            handleActivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, activarás la parametrización seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, activar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    this.isSending = true;
                    var formInput = {};
                    var id = vm.idDecode(row.id);
                    formInput = {
                            id: id,
                            data: JSON.stringify({
                                code: row.code,
                                name: (vm.clientTypes_array.find(client => client.code === row.code) || {}).name || 'Error', // Validación manual
                                balance: row.balance,
                                quota: row.quota,
                                active: true
                            })
                    };
                    this.$apollo.mutate({
                        mutation: CREATE_CONTINGENT_QUOTA_AGRO,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if (data.data.contingentQuotaTdcAgro.errors.length == 0) {
                            let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === row.id)
                            if (indexToDelete >= 0) {
                                vm.tableData.splice(indexToDelete, 1)
                            }
                            vm.pushData(data.data.contingentQuotaTdcAgro.contingentQuotaTDCAgro);
                            vm.orderData();
                            vm.isSending = false;
                            swal({
                            title: '¡Activada!',
                            text: 'La parametrización ha sido activada',
                            type: 'success',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                            }).then(() => {
                                vm.reloadData();
                            },function (dismiss){
                                vm.reloadData();
                            });
                        }
                        else {
                            vm.isSending = false;
                            vm.showNotificationError(data.data.contingentQuotaTdcAgro.errors[0].messages[0]);
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'La parametrización no ha sido activada',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /**
            * Función que pone el foco en el campo de code
            */
            focusFirstField(){
                var vm = this;
                if(vm.addContingentQuota)
                {
                    this.$refs.balance.$el.children[0].focus();//Asignamos focus en el campo
                }
                else if(vm.editContingentQuota)
                {
                    this.$refs.balance.$el.children[0].focus();//Asignamos focus en el campo
                }
            },
            /**
            * Función para asignar el true o false a las opciones de agregar y editar tipos de cuota contingente
            */
            setVisibleForm(add,edit)
            {
            this.addContingentQuota = add;
            this.editContingentQuota = edit;
            },
            /*** 
            * Función que resetea el formulario
            */
            resetForm(){
                this.model.id = '';
                this.model.code = '';
                this.model.name = '';
                this.model.balance = null;
                this.model.quota = null;
                this.model.active = true;
            },
            /*** 
            * Función que cancela la creación/edición de tipo de cuota contingente y resetea los campos
            */
            cancelForm(){
                this.resetForm();
                this.addContingentQuota = false;
                this.editContingentQuota = false;
                this.errors.clear();
                window.scrollTo(0,0);
                // this.$router.go();
            },
            /*** 
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /*** 
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false)//Asignamos las variables de visualización del formulario 
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushData(node){
                var vm = this;
                vm.tableData.push({
                    id: node.id,
                    code: node.data.code,
                    name: node.data.name,
                    balance: node.data.balance,
                    quota: node.data.quota,
                    active: node.data.active
                });
            // Ordenar tableData por from de menor a mayor
            vm.tableData.sort((a, b) => a.code - b.code);
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushClientTypesData(node){
                var vm = this;
                vm.clientTypes_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    isActive: node.isActive,
                });
            // Ordenar tableData por from de menor a mayor
            vm.tableData.sort((a, b) => a.code - b.code);
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.tableData, o => o.name);
                vm.tableData = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderClientTypesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.clientTypes_array, o => o.name);
                vm.clientTypes_array = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
            * Función para mostrar un mensaje de error
            */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    var formInput = {};
                    var formMessage = ""; 
                    vm.isSending = true;
                    let exists = vm.tableData.some(item => item.code === vm.model.code);
                    if (exists && !vm.editContingentQuota) {
                        vm.onError('El tipo de cliente ya ha sido parametrizado');
                        vm.isSending = false;
                        return;
                    } 
                    if(vm.addContingentQuota && !vm.editContingentQuota)
                    {
                        formInput = {
                            data: JSON.stringify({
                                code: vm.model.code,
                                name: (vm.clientTypes_array.find(client => client.code === vm.model.code) || {}).name || 'Error', // Validación manual
                                balance: vm.model.balance,
                                quota: vm.model.quota,
                                active: true
                            })
                        };
                        formMessage = "Tipo de cuota contingente registrado con éxito";
                    }
                    else if(!vm.addContingentQuota && vm.editContingentQuota)
                    {
                        var id = vm.idDecode(vm.model.id);
                        formInput = {
                                id: id,
                                data: JSON.stringify({
                                    code: vm.model.code,
                                    name: (vm.clientTypes_array.find(client => client.code === vm.model.code) || {}).name || 'Error', // Validación manual
                                    balance: vm.model.balance,
                                    quota: vm.model.quota,
                                    active: vm.model.active
                                })
                        };
                        formMessage = "Tipo de cuota contingente editado con éxito";
                    }
                    console.log(formInput);
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: CREATE_CONTINGENT_QUOTA_AGRO,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if (data.data.contingentQuotaTdcAgro.errors.length == 0) {
                            if(!vm.addContingentQuota && vm.editContingentQuota)
                            {
                                let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === vm.rowEdit.id)
                                if (indexToDelete >= 0) {
                                    vm.tableData.splice(indexToDelete, 1)
                                }
                            }
                            vm.pushData(data.data.contingentQuotaTdcAgro.contingentQuotaTDCAgro);
                            vm.orderData();
                            vm.isSending = false;
                            vm.onSuccess(formMessage);
                            vm.reloadData();
                        }
                        else {
                            vm.isSending = false;
                            vm.showNotificationError(data.data.contingentQuotaTdcAgro.errors[0].messages[0]);
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                })
        }
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
    // Estilos para poder centrar el título de la Regional
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
